import Drywall from './../../apps/components/Drywall';

export default {
  path: '/otros-productos',
  exact: 'true',
  component: Drywall,
};